import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-92de30c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "sku-container",
  ref: "refSkuBox"
}
const _hoisted_2 = {
  key: 0,
  class: "wrong-page"
}
const _hoisted_3 = {
  key: 1,
  class: "wrong-page-sku-content"
}
const _hoisted_4 = { class: "sku-info" }
const _hoisted_5 = {
  key: 0,
  class: "info-cover"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "info-desc" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "title-top" }
const _hoisted_10 = {
  class: "title-box",
  ref: "gradeRef"
}
const _hoisted_11 = {
  key: 0,
  class: "tip"
}
const _hoisted_12 = { class: "u-intro" }
const _hoisted_13 = { class: "progress" }
const _hoisted_14 = { class: "progress-count" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_17 = { class: "progress-bar" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "u-card-title" }, "知识点卡牌", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  class: "card-title",
  ref: "refTabWrap"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "u-card-title" }, "知识点卡牌", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "sku-out-content" }
const _hoisted_24 = { class: "sku-task-container" }
const _hoisted_25 = {
  key: 0,
  class: "new-member-guide"
}
const _hoisted_26 = {
  key: 1,
  class: "new-member-guide"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-card" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WrongPage = _resolveComponent("WrongPage")!
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_ActionBar = _resolveComponent("ActionBar")!
  const _component_van_progress = _resolveComponent("van-progress")!
  const _component_SkuCard = _resolveComponent("SkuCard")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.showWrongPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_WrongPage, {
            showActionBar: $setup.showActionBar,
            onClickRefresh: $setup.clickRefresh
          }, null, 8, ["showActionBar", "onClickRefresh"])
        ]))
      : _createCommentVNode("", true),
    (!$setup.showWrongPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          ($setup.isLoading)
            ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
            : _createCommentVNode("", true),
          ($setup.showActionBar)
            ? (_openBlock(), _createBlock(_component_ActionBar, {
                key: 1,
                onGoBack: $setup.goBack,
                onGoShare: $setup.doShare,
                actionBarInfo: $setup.actionBarInfo,
                needShare: true
              }, null, 8, ["onGoBack", "onGoShare", "actionBarInfo"]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", {
            ref: "refCardDetailWrap",
            class: "sku-info-bg",
            style: _normalizeStyle({ paddingTop: $setup.showActionBar ? $setup.actionBarHeight + 'px' : '0' })
          }, [
            _createElementVNode("div", _hoisted_4, [
              ($setup.skuInfo.column_img)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: $setup.skuInfo.column_img
                    }, null, 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString($setup.skuInfo.column_title), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["title-bottom", {'el-overflow': $setup.gradeOverflow < 0}]),
                      ref: "gradeWrapRef"
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.skuInfo.show_grade, (item, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            _createTextVNode(_toDisplayString(item) + " ", 1),
                            (index !== $setup.skuInfo.show_grade.length - 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ], 512)
                    ], 2)
                  ]),
                  ($setup.skuInfo?.button_title)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "m-intro",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.doJumpVedio && $setup.doJumpVedio(...args)))
                      }, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString($setup.skuInfo.button_title), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString($setup.skuInfo.finish_card_num || 0) + " ", 1),
                      _hoisted_16,
                      _createTextVNode(" " + _toDisplayString($setup.skuInfo.card_num), 1)
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_17, [
                    _createVNode(_component_van_progress, {
                      color: "#fff",
                      "track-color": "rgba(0, 0, 0, 0.04)",
                      "show-pivot": false,
                      percentage: 
                    Math.floor(($setup.skuInfo.finish_card_num / $setup.skuInfo.card_num) * 100)
                  ,
                      "stroke-width": "0.15rem"
                    }, null, 8, ["percentage"])
                  ])
                ])
              ])
            ])
          ], 4), [
            [_vShow, $setup.skuInfo?.column_title]
          ]),
          _createElementVNode("div", {
            class: "card-title m-task-tab-wrap-fixed",
            ref: "refTabWrapFixed",
            style: _normalizeStyle({top: $setup.showActionBar ? `${$setup.actionBarHeight}px` : 0, display: $setup.displayTabWrapFixed})
          }, _hoisted_19, 4),
          _createElementVNode("div", _hoisted_20, _hoisted_22, 512),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              class: "sku-list",
              style: _normalizeStyle({ top: $setup.showActionBar ? $setup.actionBarHeight + 'px' : '0' })
            }, [
              _createVNode(_component_van_list, {
                class: "sku-task",
                loading: $setup.loading,
                "onUpdate:loading": _cache[5] || (_cache[5] = ($event: any) => (($setup.loading) = $event)),
                finished: $setup.finished,
                "loading-text": "正在加载…",
                "finished-text": $setup.cardList.length >= 6 ? '- 我有止境，学无止境哦 -' : '',
                onLoad: $setup.onLoad,
                "immediate-check": false,
                ref: "vanTabs"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardList, (item, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.unionid,
                        class: "sku-task-item"
                      }, [
                        (_openBlock(), _createBlock(_component_SkuCard, {
                          onHandleToDetail: $setup.handleToDetail,
                          cardInfo: item,
                          key: key
                        }, null, 8, ["onHandleToDetail", "cardInfo"])),
                        (key === 0 && $setup.isShowFirstInGuide)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createElementVNode("div", {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.hideFirstInGuide(1))),
                                id: "guide-lottie-container",
                                class: "guide-lottie"
                              }),
                              _createElementVNode("div", {
                                class: "guide-text",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.hideFirstInGuide(1)))
                              }, [
                                _createElementVNode("span", null, _toDisplayString($setup.oneStarGuideTitle), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (key === 0 && $setup.isShowTwoStarGuide)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("div", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.hideFirstInGuide(2))),
                                id: "guide-lottie-container2",
                                class: "guide-lottie"
                              }),
                              _createElementVNode("div", {
                                class: "guide-text guide-two-star",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.hideFirstInGuide(2)))
                              }, [
                                _createElementVNode("span", null, _toDisplayString($setup.twoStarGuideTitle), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    ($setup.cardList?.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(1, (index) => {
                          return _createElementVNode("div", {
                            key: `sku-task-item-${index}`,
                            class: "sku-task-item"
                          }, _hoisted_28)
                        }), 64))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["loading", "finished", "finished-text", "onLoad"])
            ], 4)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}